export interface PolicySection {
  heading: string;
  body: string;
}

export interface LegalDocument {
  id: string;
  label: string;
  title: string;
  updatedAt: string;
  sections: PolicySection[];
}

const DRAFT_NOTICE =
  '[BORRADOR — REVISAR ANTES DE PUBLICAR] Este texto es provisional y debe ser revisado por el responsable legal de Jam Fragrances antes de la publicación del sitio.';

export const legalDocuments: LegalDocument[] = [
  {
    id: 'privacidad',
    label: 'Política de privacidad',
    title: 'Política de privacidad',
    updatedAt: 'Última actualización: pendiente de definir',
    sections: [
      { heading: 'Aviso', body: DRAFT_NOTICE },
      {
        heading: 'Datos que recopilamos',
        body: '[PROVISIONAL] Recopilamos el nombre, correo electrónico, dirección de envío y teléfono que ingresas al realizar una compra, así como datos de navegación anónimos para mejorar la experiencia del sitio.',
      },
      {
        heading: 'Cómo usamos tus datos',
        body: '[PROVISIONAL] Utilizamos tus datos para procesar pedidos, coordinar el envío, atender aclaraciones y, si lo autorizas, enviarte novedades de la marca. No vendemos ni rentamos tu información a terceros.',
      },
      {
        heading: 'Pedidos por WhatsApp',
        body: '[PROVISIONAL] Los pedidos se coordinan por WhatsApp. La conversación y los datos que compartas ahí se rigen también por la política de privacidad de WhatsApp. No solicitamos ni almacenamos datos completos de tarjetas por ese medio.',
      },
      {
        heading: 'Tus derechos',
        body: '[PROVISIONAL] Puedes solicitar el acceso, la rectificación, la cancelación o la oposición al tratamiento de tus datos escribiéndonos por WhatsApp al +1 (323) 385-5169. Responderemos en un plazo máximo de 20 días hábiles.',
      },
    ],
  },
  {
    id: 'terminos',
    label: 'Términos y condiciones',
    title: 'Términos y condiciones',
    updatedAt: 'Última actualización: pendiente de definir',
    sections: [
      { heading: 'Aviso', body: DRAFT_NOTICE },
      {
        heading: 'Aceptación',
        body: '[PROVISIONAL] Al navegar y comprar en este sitio aceptas estos términos. Si no estás de acuerdo con alguno de ellos, te pedimos no realizar la compra.',
      },
      {
        heading: 'Productos y precios',
        body: '[PROVISIONAL] Los precios se muestran en dólares estadounidenses e incluyen el precio de lanzamiento vigente. Podemos modificar precios y disponibilidad sin previo aviso; el precio aplicable es el mostrado al momento de completar el pedido.',
      },
      {
        heading: 'Pedidos',
        body: '[PROVISIONAL] Nos reservamos el derecho de cancelar pedidos con datos incompletos, sospecha de fraude o falta de existencias, notificándote y reembolsando el importe íntegro.',
      },
      {
        heading: 'Propiedad intelectual',
        body: '[PROVISIONAL] Las marcas de los perfumes pertenecen a sus respectivos titulares. El contenido, las fotografías y el diseño de este sitio son propiedad de Jam Fragrances.',
      },
    ],
  },
  {
    id: 'envios',
    label: 'Política de envíos',
    title: 'Política de envíos',
    updatedAt: 'Última actualización: pendiente de definir',
    sections: [
      { heading: 'Aviso', body: DRAFT_NOTICE },
      {
        heading: 'Costo',
        body: '[PROVISIONAL] El envío es totalmente gratuito en todos los pedidos, sin monto mínimo de compra.',
      },
      {
        heading: 'Tiempos de preparación y entrega',
        body: '[PROVISIONAL] Preparamos cada pedido en un máximo de 24 horas hábiles. La entrega tarda de 3 a 5 días hábiles adicionales según la zona de destino.',
      },
      {
        heading: 'Seguimiento',
        body: '[PROVISIONAL] Todos los pedidos viajan con guía rastreable y seguro incluido. Recibirás el número de rastreo por correo en cuanto el paquete salga de nuestro almacén.',
      },
      {
        heading: 'Incidencias',
        body: '[PROVISIONAL] Si tu paquete se retrasa, llega dañado o se extravía, escríbenos por WhatsApp al +1 (323) 385-5169 dentro de los 7 días posteriores a la fecha estimada de entrega y lo resolvemos.',
      },
    ],
  },
  {
    id: 'devoluciones',
    label: 'Devoluciones y reembolsos',
    title: 'Devoluciones y reembolsos',
    updatedAt: 'Última actualización: pendiente de definir',
    sections: [
      { heading: 'Aviso', body: DRAFT_NOTICE },
      {
        heading: 'Plazo',
        body: '[PROVISIONAL] Cuentas con 30 días naturales desde la recepción para solicitar una devolución, incluso si el frasco fue abierto y se usó hasta un 20% del contenido.',
      },
      {
        heading: 'Cómo solicitarla',
        body: '[PROVISIONAL] Escríbenos por WhatsApp al +1 (323) 385-5169 con los datos de tu pedido y el motivo. Te enviaremos la guía de retorno prepagada; la primera guía nacional corre por nuestra cuenta.',
      },
      {
        heading: 'Reembolsos',
        body: '[PROVISIONAL] Una vez recibido y revisado el producto, acordamos contigo por WhatsApp el reembolso al mismo medio con el que pagaste, en un plazo de 5 a 10 días hábiles.',
      },
      {
        heading: 'Excepciones',
        body: '[PROVISIONAL] No se aceptan devoluciones de productos sin su empaque original, con daños atribuibles al uso indebido o adquiridos fuera de este sitio.',
      },
    ],
  },
];
